import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "品类导航",
    links: [
      { label: "时尚服饰", to: "/category/fashion" },
      { label: "美妆护肤", to: "/category/beauty" },
      { label: "美食特产", to: "/category/food" },
      { label: "工艺精品", to: "/category/craft" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { label: "品牌介绍", to: "/about" },
      { label: "品牌信誉", to: "/about" },
      { label: "联系我们", to: "/about" },
    ],
  },
  {
    title: "内容中心",
    links: [
      { label: "精选文章", to: "/articles" },
      { label: "品牌推荐", to: "/category/fashion" },
      { label: "好物清单", to: "/category/food" },
    ],
  },
];

export default function Footer() {
  const handleNewsletterSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypot && honeypot.value.trim() !== "") {
      return;
    }
    const formData = new FormData(form);
    if (honeypot) formData.delete("website_alt");
    fetch("https://readdy.ai/api/form/d9u4kdd3pcjqs2fcsm3g", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
    })
      .then(async (res) => {
        const text = await res.text();
        try {
          const json = JSON.parse(text);
          if (res.ok && json.code === "OK") {
            alert("订阅成功！感谢您的关注。");
            form.reset();
          } else {
            alert("订阅失败，请稍后再试。");
          }
        } catch {
          alert("订阅失败，请稍后再试。");
        }
      })
      .catch(() => {
        alert("网络错误，请稍后再试。");
      });
  };

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand column */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="text-xl font-heading font-semibold text-foreground-950 no-underline whitespace-nowrap">
              亚洲精品
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-xs">
              甄选亚洲顶级品质产品与品牌，为您带来真正代表亚洲工艺与品味的优质推荐。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm" />
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm" />
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-bookmark-line text-sm" />
              </a>
            </div>
          </div>

          {/* Link columns */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 no-underline whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Newsletter */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">订阅资讯</h4>
            <p className="text-sm text-foreground-600 mb-4">
              获取最新亚洲精品推荐和独家优惠
            </p>
            <form onSubmit={handleNewsletterSubmit} data-readdy-form className="flex flex-col gap-2">
              <input
                type="email"
                name="email"
                placeholder="请输入邮箱地址"
                required
                className="px-3 py-2 text-sm rounded-md border border-background-300 bg-background-50 text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-300 transition-all"
              />
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <button
                type="submit"
                className="px-4 py-2 text-sm font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer border-none"
              >
                立即订阅
              </button>
            </form>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 亚洲精品 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}